import React from "react";
import moment from "moment";
import moment2 from "moment-timezone";
import { useSignal, useSlot } from 'react-signal-slot';
import { BaseLotInfoByOrganizator } from "../../../Models/Lots/LotInfoByOrganizator";
import { GetBetsTablePromise, GetDocumentsPromise, GetApplicationsPromise, GetBetsPromise, FinishTrade, AssignTradeAsFailed, ContinueTrade } from "./remote";
import RemoveTradeLot from "../baseComponent/RemoveTradeLot";
import DocumentsTable from "../../../Tables/DocumentsTable";
import { TableMode } from "../../../enums/TableTypes";
import Table from "../../../Tables/Table";
import TradeDocuments from "../baseComponent/TradeDocuments";
import Loading from "../../../Ui/Loading";
import { DocumentTypesDescription, IDocumentModel } from "../../../Common/types";
import { ApplicationStatusses } from "../../../TradeApplication/types";
import Popup from "../../../Popups/Popup";
import ApplicationsForMyActivity from "../ApplicationsForMyActivity";
import { TradeStatus } from "../../../enums/TradeStatus";
import LotWinnerProtocol2 from "../../../Common/Document/LotWinnerProtocol2";
import LotWinnerProtocol from "../../../Common/Document/LotWinnerProtocol";
import AccountInfo from "../../../Profile/AccountInfo";

interface IPropsType {
    lot?: BaseLotInfoByOrganizator;
    onRemove: (id) => any;
}

export class BaseComponent extends React.Component<IPropsType> {
    constructor(props) {
        super(props);

        this.state = {
            Lot: props.lot,
            onRemove: props.onRemove,
            ActiveMenu: "",
            Applications: [],
            isLoading: false,
        };

        this.activeDetails = this.activeDetails.bind(this);
    }

    init(state) {
        this.setState(state);
    }

    detailsMenu() {
        return (
            <div className="lotDetails">
                <button
                    onClick={() => this.setState({ ...this.state, ActiveMenu: "Documents" })}
                    className={this.state.ActiveMenu === "Documents" && "active"}
                >Документы</button>
                <button
                    onClick={() => this.setState({ ...this.state, ActiveMenu: "Bets" })}
                    className={this.state.ActiveMenu === "Bets" && "active"}
                >Ставки({this.state.Lot?.Bets?.length > 0 ? this.state.Lot?.Bets?.length : 0})</button>
                <button
                    onClick={() => this.setState({ ...this.state, ActiveMenu: "LotDetails" })}
                    className={this.state.ActiveMenu === "LotDetails" && "active"}
                >Детали</button>
            </div>
        );
    }

    activeDetails = () => {
        if (this.state.ActiveMenu === "Documents") return this.Documents();
        if (this.state.ActiveMenu === "Bets") return this.Bets();
        if (this.state.ActiveMenu === "Applications") return this.Applications();
        if (this.state.ActiveMenu === "LotDetails") return this.Details();
    };

    GetDate(date) {
        return moment2(date).format("DD.MM.YYYY HH:mm");
    }

    getDocuments = () => {
        GetDocumentsPromise(this.state.Lot.Id).then((result) => {
            console.log('MyActivity BaseComponent getDocuments: ', result);
            this.setState({ ...this.state, Lot: { ...this.state.Lot, Documents: result } });
        });
    };

    onRemoveDocument(id) {
        this.setState({
            ...this.state,
            Lot: { ...this.state.Lot, Documents: this.state.Lot.Documents.filter(doc => doc.Id !== id) }
        });
    }

    getBets() {
        GetBetsTablePromise(this.state.Lot.LotId).then((result) => {
            console.log('MyActivity BaseComponent getBets: ', result);
            this.setState({ ...this.state, Lot: { ...this.state.Lot, Bets: result } });
        });
    }

    updateBets(lotId) {
        GetBetsPromise(lotId).then((result) => {
            console.log(`Updated bets for the lot ${lotId}`, result.UpdatedItem);
            this.setState(prev => ({
                Lot: {
                    ...prev.Lot,
                    Bets: result.UpdatedItem
                }
            }), () => {
                console.log("new state", this.state);
            });
        });
    }

    handleContinueTrade(lotId) {
        this.setState({ isLoading: true }, () => {
            console.log("isLoading после установки:", this.state.isLoading);
        });

        ContinueTrade(lotId)
            .then((result) => {
                console.log("result after to continue trade", result);
                this.setState(prev => ({
                    Lot: {
                        ...prev.Lot,
                        LotTradeStatusId: result.UpdatedItem.LotTradeStateId,
                        LotTradeStatusDescription: result.UpdatedItem.LotTradeStateDescription
                    },
                    isLoading: false
                }), () => {
                    console.log("this.isLoading", this.state.isLoading);
                });
            });
    }

    handleFinishTrade(lotId) {
        this.setState({ isLoading: true }, () => {
            console.log("isLoading после установки:", this.state.isLoading);
        });

        FinishTrade(lotId)
            .then((result) => {
                console.log("result after to finish trade", result);
                this.setState(prev => ({
                    Lot: {
                        ...prev.Lot,
                        LotTradeStatusId: result.UpdatedItem.LotTradeStateId,
                        LotTradeStatusDescription: result.UpdatedItem.LotTradeStateDescription
                    },
                    isLoading: false
                }), () => {
                    console.log("this.isLoading", this.state.isLoading);
                });
            });
    }

    handleAssignTradeAsFailed(lotId) {
        this.setState({ isLoading: true }, () => {
            console.log("isLoading после установки:", this.state.isLoading);
        });

        AssignTradeAsFailed(lotId)
            .then((result) => {
                console.log("result after to finish trade", result);
                this.setState(prev => ({
                    Lot: {
                        ...prev.Lot,
                        LotTradeStatusId: result.UpdatedItem.LotTradeStateId,
                        LotTradeStatusDescription: result.UpdatedItem.LotTradeStateDescription
                    },
                    isLoading: false
                }), () => {
                    console.log("this.isLoading", this.state.isLoading);
                });
            });
    }

    Details() {
        return (
            <>
                <div className="aboutTrade detailsWrapper">
                    <div className="tradeInfo">
                        <div className="infoItem">
                            <span className="defaultDataName">Вид торгов:</span>
                            <p className="defaultDataValue">{this.state.Lot.TradeTypeDescription}</p>
                        </div>
                        <div className="infoItem">
                            <span className="defaultDataName">Статус:</span>
                            <p className="defaultDataValue">{this.state.Lot.LotTradeStatusDescription}</p>
                        </div>
                        {this.state.Lot.LotTradePeriodStart &&
                            <div className="infoItem">
                                <span className="defaultDataName">Начало аукциона:</span>
                                <p className="defaultDataValue">
                                    {this.GetDate(this.state.Lot.LotTradePeriodStart)}
                                </p>
                            </div>
                        }

                        {this.state.Lot.LotTradePeriodEnd &&
                            <div className="infoItem">
                                <span className="defaultDataName">Окончание аукциона:</span>
                                <p className="defaultDataValue">
                                    {this.GetDate(this.state.Lot.LotTradePeriodEnd)}
                                </p>
                            </div>
                        }
                    </div>
                </div>
            </>
        );
    }

    Documents() {
        return (
            <>
                <TradeDocuments
                    documents={this.state.Lot.Documents}
                    getDocuments={this.getDocuments}
                    lotId={this.state.Lot.Id}
                />
            </>
        );
    }

    renderDocName = (rowData: IDocumentModel) => (
        <div className="elWrap" key={rowData.Id}>
            {rowData.Name}
            {rowData.MimeType &&
                <span className="fileExtension">
                    {rowData.MimeType.includes(".") ? rowData.MimeType.split(".")?.pop() : rowData.MimeType.split("/")?.pop()}
                </span>
            }
            <a href={rowData.DocumentLink || rowData.Path} download className="downloadDocButton">
                <img src="../../../main-images/downloadDocIcon.png"></img>
            </a>
        </div>
    );

    isShowApplications() {
        return (
            this.state.Lot.LotTradeStatusId === TradeStatus.ApplicationProcessing ||
            this.state.Lot.LotTradeStatusId === TradeStatus.WaitingForTrade ||
            this.state.Lot.LotTradeStatusId === TradeStatus.Trading ||
            this.state.Lot.LotTradeStatusId === TradeStatus.TradeAbandoned ||
            this.state.Lot.LotTradeStatusId === TradeStatus.WaitingDecision ||
            this.state.Lot.LotTradeStatusId === TradeStatus.WaitingDecisionAfterTrade ||
            this.state.Lot.LotTradeStatusId === TradeStatus.Traded
        );
    }

    Applications() {
        if (this.isShowApplications()) {
            return (
                <ApplicationsForMyActivity
                    applications={this.state.Lot.Applications}
                    documents={this.state.Lot.Documents} // Передаем документы лота
                    renderDocName={this.renderDocName}
                    lotId={this.state.Lot.Id}
                    page={this.state.Lot.Page}
                    tradeStatusId={this.state.Lot.LotTradeStatusId}
                />
            );
        } else {
            return <p>Вы сможете увидеть заявки, начиная со статуса Обработка заявок</p>
        }
    }

    Bets() {
        return (
            <>
                <button className="defaultSmallPinkButton"
                    style={{
                        marginBottom: "10px",
                    }}
                    onClick={() => this.updateBets(this.state.Lot.Id)}>Обновить</button>
                <Table
                    data={this.state.Lot.Bets}
                    columns={[
                        {
                            name: "UserName", title: "Пользователь", body: (rowData) => {
                                let nums = [];
                                this.state.Lot.Bets.forEach(bet => {
                                    if (nums.includes(bet.CompanyId)) return;
                                    nums.push(bet.CompanyId);
                                })

                                return (
                                    `Участник ${nums.indexOf(rowData.CompanyId) + 1} ${AccountInfo.CompanyId == rowData.CompanyId ? "(Это вы)" : ""}`
                                )
                            }
                        },
                        {
                            name: "Price", title: "Цена",
                            body: (rowData) => (
                                <>
                                    {rowData.Price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}
                                </>
                            )
                        },
                        {
                            name: "StartPriceDate", title: "Дата",
                            body: (rowData) => (
                                <>{moment(rowData.StartPriceDate).format('DD.MM.YYYY')}</>
                            )
                        },
                    ]}
                />
            </>
        );
    }

    renderTradeHint() {
        return null;
    }

    renderIsDeposit() {
        return null;
    }

    getIsStatusForAction() {
        return (
            this.state.Lot.LotTradeStatusId === TradeStatus.New ||
            this.state.Lot.LotTradeStatusId === TradeStatus.Approved ||
            (this.state.Lot.LotTradeStatusId === TradeStatus.WaitingForTrade && !this.state.Lot.IsApplications) ||
            this.state.Lot.LotTradeStatusId === TradeStatus.WaitingForConfirmation ||
            this.state.Lot.LotTradeStatusId === TradeStatus.WaitingForStartAllowAcceptance ||
            this.state.Lot.LotTradeStatusId === TradeStatus.Draft ||
            this.state.Lot.LotTradeStatusId === TradeStatus.Draft2
        );
    }

    ShortInfoLot() {
        return (
            <React.Fragment>
                <div className="cardContent">
                    <div className="cardImage">
                        <a href={"/TradeLot/View/" + this.state.Lot.Id}>
                            {(this.state.Lot.Picture && this.state.Lot.Picture.ThumbnailUrl && this.state.Lot.Picture.ThumbnailUrl.length > 0) ?
                                <img className="img-100w" key={this.state.Lot.Picture.Id} src={this.state.Lot.Picture.ThumbnailUrl} alt={this.state.Lot.Picture.FileName} />
                                :
                                <img src="../../main-images/defaultLotImage.png" className="img-100w" alt="Картинка по умолчанию" />
                            }
                        </a>
                    </div>
                    <div className="cardInfo">
                        {this.renderTradeHint()}
                        {this.state.Lot?.DateCreated && <p className="dateCreatedLot defaultDescription">Дата создания: {this.GetDate(this.state.Lot?.DateCreated)}</p>}

                        <a className="cardName" href={"/TradeLot/View/" + this.state.Lot.Id}>
                            {this.state.Lot.Name}
                        </a>
                        <div className="cardDescription">
                            <div className="cartType cardDescriptionItem">
                                <h5>Тип торга:</h5>
                                <span>{this.state.Lot.TradeTypeDescription}</span>
                                <span style={{ whiteSpace: 'pre-line' }}><i>{this.state.Lot.AdditionalAuctionParameters}</i></span>
                            </div>
                            <div className="cardTypeSale cardDescriptionItem">
                                <h5>Статус:</h5>
                                <span>{this.state.Lot.LotTradeStatusDescription}</span>
                            </div>
                            <div className="cardNumber cardDescriptionItem">
                                <h5>Номер лота:</h5>
                                <span>{this.state.Lot.Id}</span>
                            </div>
                            <div className="cardPrice cardDescriptionItem">
                                <h5>Текущая цена:</h5>
                                <span>{this.state.Lot.CurrentPrice ? this.state.Lot.CurrentPrice : this.state.Lot.BasePrice} ₽</span>
                            </div>
                        </div>

                        {(this.state.Lot.LotTradeStatusId === TradeStatus.WaitingDecision ||
                            this.state.Lot.LotTradeStatusId === TradeStatus.WaitingDecisionAfterTrade) &&
                            <div style={{ display: "flex", justifyContent: "end", gap: "10px" }}>
                                {this.state.isLoading && (
                                    <>
                                        <p>Загрузка...</p>
                                        <Loading />
                                    </>
                                )}
                                {this.state.Lot.LotTradeStatusId === TradeStatus.WaitingDecisionAfterTrade && <button
                                    className="defaultSmallPinkButton"
                                    onClick={() => this.handleFinishTrade(this.state.Lot.Id)}>
                                    Завершить торг
                                </button>}
                                {this.state.Lot.LotTradeStatusId === TradeStatus.WaitingDecision && <button
                                    className="defaultSmallPinkButton"
                                    onClick={() => this.handleContinueTrade(this.state.Lot.Id)}>
                                    Продолжить торг
                                </button>}
                                <button
                                    className="defaultSmallPinkButton"
                                    onClick={() => this.handleAssignTradeAsFailed(this.state.Lot.Id)}>
                                    Признать не состоявшимся
                                </button>
                            </div>}

                        <div className="cardActions">
                            {(this.state.Lot.LotTradeStatusId === TradeStatus.TradeAbandoned ||
                                this.state.Lot.LotTradeStatusId === TradeStatus.Traded) &&
                                <LotWinnerProtocol lotId={this.state.Lot.Id} LotTradeStatusId={this.state.Lot.LotTradeStatusId} key={this.state.Lot.Id} IsShortInfo={true} />}

                            <div className="lotActions">
                                {this.getIsStatusForAction() &&
                                    <>
                                        <a href={`/TradeLotEdit/EditLot?lotId=${this.state.Lot.Id}`}>
                                        <svg style={{ marginRight: "10px" }} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
                                            <g clip-path="url(#clip0_403_3434)">
                                                <path d="M22.94 1.05872C22.2602 0.379917 21.3387 -0.00134277 20.378 -0.00134277C19.4173 -0.00134277 18.4958 0.379917 17.816 1.05872L0 18.8747V23.9987H5.124L22.94 6.18272C23.6186 5.50274 23.9997 4.58135 23.9997 3.62072C23.9997 2.66009 23.6186 1.7387 22.94 1.05872ZM4.3 21.9987H2V19.6987L15.31 6.39872L17.61 8.69872L4.3 21.9987ZM21.526 4.76872L19.019 7.27572L16.724 4.97572L19.23 2.47272C19.535 2.16772 19.9487 1.99637 20.38 1.99637C20.8113 1.99637 21.225 2.16772 21.53 2.47272C21.835 2.77772 22.0063 3.19139 22.0063 3.62272C22.0063 4.05405 21.835 4.46772 21.53 4.77272L21.526 4.76872Z" fill="black" fill-opacity="0.5" />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_403_3434">
                                                    <rect width="24" height="24" fill="white" />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                        Редактировать</a>
                                        <RemoveTradeLot
                                            id={this.state.Lot.Id}
                                            onRemove={this.state.onRemove}
                                        />
                                    </>
                                }
                            </div>

                            {this.detailsMenu()}

                            {!this.getIsStatusForAction() &&
                                <p className="errorText">Данный лот уже не доступен для редактирования и удаления</p>
                            }
                        </div>
                    </div>
                </div>
                <div className="details" style={{ position: "relative" }}>
                    {this.activeDetails()}
                </div>
            </React.Fragment>
        );
    }

    render() {
        return this.ShortInfoLot();
    }
}